/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CentreSpendAttributionData } from './CentreSpendAttributionData';
import {
    CentreSpendAttributionDataFromJSON,
    CentreSpendAttributionDataFromJSONTyped,
    CentreSpendAttributionDataToJSON,
    CentreSpendAttributionDataToJSONTyped,
} from './CentreSpendAttributionData';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface ShopPerformance
 */
export interface ShopPerformance {
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderAverageNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderAverageNetGranular?: { [key: string]: NullableMoneyOutput; };
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderAverageGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderAverageGrossGranular?: { [key: string]: NullableMoneyOutput; };
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderProfitNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderProfitNetGranular?: { [key: string]: NullableMoneyOutput; };
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderProfitGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderProfitGrossGranular?: { [key: string]: NullableMoneyOutput; };
    /**
     * 
     * @type {boolean}
     * @memberof ShopPerformance
     */
    purchaseCostCompleteNet?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShopPerformance
     */
    purchaseCostCompleteGross?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShopPerformance
     */
    currency?: string;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof ShopPerformance
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {ShopPerformanceFinanceScopeEnum}
     * @memberof ShopPerformance
     */
    financeScope?: ShopPerformanceFinanceScopeEnum;
    /**
     * 
     * @type {{ [key: string]: MediaSourceQuality; }}
     * @memberof ShopPerformance
     */
    mediaSourceQualityGranular?: { [key: string]: MediaSourceQuality; };
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ShopPerformance
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {{ [key: string]: PartialProfitabilityData; }}
     * @memberof ShopPerformance
     */
    partialProfitabilityGranular?: { [key: string]: PartialProfitabilityData; };
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ShopPerformance
     */
    partialProfitabilityMarketing?: PartialProfitabilityData | null;
    /**
     * 
     * @type {{ [key: string]: PartialProfitabilityData; }}
     * @memberof ShopPerformance
     */
    partialProfitabilityMarketingGranular?: { [key: string]: PartialProfitabilityData; };
    /**
     * 
     * @type {CentreSpendAttributionData}
     * @memberof ShopPerformance
     */
    centreSpendAttribution?: CentreSpendAttributionData | null;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof ShopPerformance
     */
    snapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderTurnoverNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderTurnoverNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderTurnoverGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderTurnoverCancelled?: NullableMoneyOutput | null;
    /**
     * 
     * @type {ShopPerformanceCancelledTurnoverUnavailableReasonEnum}
     * @memberof ShopPerformance
     */
    cancelledTurnoverUnavailableReason?: ShopPerformanceCancelledTurnoverUnavailableReasonEnum | null;
    /**
     * 
     * @type {{ [key: string]: ShopPerformanceCancelledTurnoverUnavailableReasonsGranularEnum; }}
     * @memberof ShopPerformance
     */
    cancelledTurnoverUnavailableReasonsGranular?: { [key: string]: ShopPerformanceCancelledTurnoverUnavailableReasonsGranularEnum; };
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderTurnoverGrossGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {{ [key: string]: NullableMoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderTurnoverCancelledGranular?: { [key: string]: NullableMoneyOutput; };
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderSpendGoodsNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderSpendGoodsGross?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    purchaseCostUnknownNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    purchaseCostUnknownGross?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    purchaseCostEstimatedNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    purchaseCostEstimatedGross?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShopPerformance
     */
    purchaseCostQualityAvailable?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    purchaseCostUnknownNetGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    purchaseCostUnknownGrossGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    purchaseCostEstimatedNetGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    purchaseCostEstimatedGrossGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ShopPerformance
     */
    purchaseCostQualityAvailableGranular?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderSpendGoodsNetGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderSpendGoodsGrossGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShopPerformance
     */
    orderSpendMarketing?: NullableMoneyOutput | null;
    /**
     * 
     * @type {{ [key: string]: MoneyOutput; }}
     * @memberof ShopPerformance
     */
    orderSpendMarketingGranular?: { [key: string]: MoneyOutput; };
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountNet?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountGross?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountCompleted?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountReceived?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShopPerformance
     */
    orderAmountCancelled?: number | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountNetGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountGrossGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountCompletedGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountReceivedGranular?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ShopPerformance
     */
    orderAmountCancelledGranular?: { [key: string]: number; };
}


/**
 * @export
 */
export const ShopPerformanceFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type ShopPerformanceFinanceScopeEnum = typeof ShopPerformanceFinanceScopeEnum[keyof typeof ShopPerformanceFinanceScopeEnum];

/**
 * @export
 */
export const ShopPerformanceCancelledTurnoverUnavailableReasonEnum = {
    ZeroHeaderWithRetainedFees: 'zero_header_with_retained_fees'
} as const;
export type ShopPerformanceCancelledTurnoverUnavailableReasonEnum = typeof ShopPerformanceCancelledTurnoverUnavailableReasonEnum[keyof typeof ShopPerformanceCancelledTurnoverUnavailableReasonEnum];

/**
 * @export
 */
export const ShopPerformanceCancelledTurnoverUnavailableReasonsGranularEnum = {
    ZeroHeaderWithRetainedFees: 'zero_header_with_retained_fees'
} as const;
export type ShopPerformanceCancelledTurnoverUnavailableReasonsGranularEnum = typeof ShopPerformanceCancelledTurnoverUnavailableReasonsGranularEnum[keyof typeof ShopPerformanceCancelledTurnoverUnavailableReasonsGranularEnum];


/**
 * Check if a given object implements the ShopPerformance interface.
 */
export function instanceOfShopPerformance(value: object): value is ShopPerformance {
    return true;
}

export function ShopPerformanceFromJSON(json: any): ShopPerformance {
    return ShopPerformanceFromJSONTyped(json, false);
}

export function ShopPerformanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopPerformance {
    if (json == null) {
        return json;
    }
    return {
        
        'orderAverageNet': json['orderAverageNet'] === undefined ? undefined : json['orderAverageNet'] === null ? null : NullableMoneyOutputFromJSON(json['orderAverageNet']),
        'orderAverageNetGranular': json['orderAverageNetGranular'] == null ? undefined : (mapValues(json['orderAverageNetGranular'], NullableMoneyOutputFromJSON)),
        'orderAverageGross': json['orderAverageGross'] === undefined ? undefined : json['orderAverageGross'] === null ? null : NullableMoneyOutputFromJSON(json['orderAverageGross']),
        'orderAverageGrossGranular': json['orderAverageGrossGranular'] == null ? undefined : (mapValues(json['orderAverageGrossGranular'], NullableMoneyOutputFromJSON)),
        'orderProfitNet': json['orderProfitNet'] === undefined ? undefined : json['orderProfitNet'] === null ? null : NullableMoneyOutputFromJSON(json['orderProfitNet']),
        'orderProfitNetGranular': json['orderProfitNetGranular'] == null ? undefined : (mapValues(json['orderProfitNetGranular'], NullableMoneyOutputFromJSON)),
        'orderProfitGross': json['orderProfitGross'] === undefined ? undefined : json['orderProfitGross'] === null ? null : NullableMoneyOutputFromJSON(json['orderProfitGross']),
        'orderProfitGrossGranular': json['orderProfitGrossGranular'] == null ? undefined : (mapValues(json['orderProfitGrossGranular'], NullableMoneyOutputFromJSON)),
        'purchaseCostCompleteNet': json['purchaseCostCompleteNet'] == null ? undefined : json['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': json['purchaseCostCompleteGross'] == null ? undefined : json['purchaseCostCompleteGross'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
        'mediaSourceQualityGranular': json['mediaSourceQualityGranular'] == null ? undefined : (mapValues(json['mediaSourceQualityGranular'], MediaSourceQualityFromJSON)),
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'partialProfitabilityGranular': json['partialProfitabilityGranular'] == null ? undefined : (mapValues(json['partialProfitabilityGranular'], PartialProfitabilityDataFromJSON)),
        'partialProfitabilityMarketing': json['partialProfitabilityMarketing'] === undefined ? undefined : json['partialProfitabilityMarketing'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitabilityMarketing']),
        'partialProfitabilityMarketingGranular': json['partialProfitabilityMarketingGranular'] == null ? undefined : (mapValues(json['partialProfitabilityMarketingGranular'], PartialProfitabilityDataFromJSON)),
        'centreSpendAttribution': json['centreSpendAttribution'] === undefined ? undefined : json['centreSpendAttribution'] === null ? null : CentreSpendAttributionDataFromJSON(json['centreSpendAttribution']),
        'snapshot': json['snapshot'] === undefined ? undefined : json['snapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
        'orderTurnoverNet': json['orderTurnoverNet'] === undefined ? undefined : json['orderTurnoverNet'] === null ? null : NullableMoneyOutputFromJSON(json['orderTurnoverNet']),
        'orderTurnoverNetGranular': json['orderTurnoverNetGranular'] == null ? undefined : (mapValues(json['orderTurnoverNetGranular'], MoneyOutputFromJSON)),
        'orderTurnoverGross': json['orderTurnoverGross'] === undefined ? undefined : json['orderTurnoverGross'] === null ? null : NullableMoneyOutputFromJSON(json['orderTurnoverGross']),
        'orderTurnoverCancelled': json['orderTurnoverCancelled'] === undefined ? undefined : json['orderTurnoverCancelled'] === null ? null : NullableMoneyOutputFromJSON(json['orderTurnoverCancelled']),
        'cancelledTurnoverUnavailableReason': json['cancelledTurnoverUnavailableReason'] === undefined ? undefined : json['cancelledTurnoverUnavailableReason'] === null ? null : json['cancelledTurnoverUnavailableReason'],
        'cancelledTurnoverUnavailableReasonsGranular': json['cancelledTurnoverUnavailableReasonsGranular'] == null ? undefined : json['cancelledTurnoverUnavailableReasonsGranular'],
        'orderTurnoverGrossGranular': json['orderTurnoverGrossGranular'] == null ? undefined : (mapValues(json['orderTurnoverGrossGranular'], MoneyOutputFromJSON)),
        'orderTurnoverCancelledGranular': json['orderTurnoverCancelledGranular'] == null ? undefined : (mapValues(json['orderTurnoverCancelledGranular'], NullableMoneyOutputFromJSON)),
        'orderSpendGoodsNet': json['orderSpendGoodsNet'] === undefined ? undefined : json['orderSpendGoodsNet'] === null ? null : NullableMoneyOutputFromJSON(json['orderSpendGoodsNet']),
        'orderSpendGoodsGross': json['orderSpendGoodsGross'] === undefined ? undefined : json['orderSpendGoodsGross'] === null ? null : NullableMoneyOutputFromJSON(json['orderSpendGoodsGross']),
        'purchaseCostUnknownNet': json['purchaseCostUnknownNet'] === undefined ? undefined : json['purchaseCostUnknownNet'] === null ? null : json['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': json['purchaseCostUnknownGross'] === undefined ? undefined : json['purchaseCostUnknownGross'] === null ? null : json['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': json['purchaseCostEstimatedNet'] === undefined ? undefined : json['purchaseCostEstimatedNet'] === null ? null : json['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': json['purchaseCostEstimatedGross'] === undefined ? undefined : json['purchaseCostEstimatedGross'] === null ? null : json['purchaseCostEstimatedGross'],
        'purchaseCostQualityAvailable': json['purchaseCostQualityAvailable'] == null ? undefined : json['purchaseCostQualityAvailable'],
        'purchaseCostUnknownNetGranular': json['purchaseCostUnknownNetGranular'] == null ? undefined : json['purchaseCostUnknownNetGranular'],
        'purchaseCostUnknownGrossGranular': json['purchaseCostUnknownGrossGranular'] == null ? undefined : json['purchaseCostUnknownGrossGranular'],
        'purchaseCostEstimatedNetGranular': json['purchaseCostEstimatedNetGranular'] == null ? undefined : json['purchaseCostEstimatedNetGranular'],
        'purchaseCostEstimatedGrossGranular': json['purchaseCostEstimatedGrossGranular'] == null ? undefined : json['purchaseCostEstimatedGrossGranular'],
        'purchaseCostQualityAvailableGranular': json['purchaseCostQualityAvailableGranular'] == null ? undefined : json['purchaseCostQualityAvailableGranular'],
        'orderSpendGoodsNetGranular': json['orderSpendGoodsNetGranular'] == null ? undefined : (mapValues(json['orderSpendGoodsNetGranular'], MoneyOutputFromJSON)),
        'orderSpendGoodsGrossGranular': json['orderSpendGoodsGrossGranular'] == null ? undefined : (mapValues(json['orderSpendGoodsGrossGranular'], MoneyOutputFromJSON)),
        'orderSpendMarketing': json['orderSpendMarketing'] === undefined ? undefined : json['orderSpendMarketing'] === null ? null : NullableMoneyOutputFromJSON(json['orderSpendMarketing']),
        'orderSpendMarketingGranular': json['orderSpendMarketingGranular'] == null ? undefined : (mapValues(json['orderSpendMarketingGranular'], MoneyOutputFromJSON)),
        'orderAmountNet': json['orderAmountNet'] === undefined ? undefined : json['orderAmountNet'] === null ? null : json['orderAmountNet'],
        'orderAmountGross': json['orderAmountGross'] === undefined ? undefined : json['orderAmountGross'] === null ? null : json['orderAmountGross'],
        'orderAmountCompleted': json['orderAmountCompleted'] === undefined ? undefined : json['orderAmountCompleted'] === null ? null : json['orderAmountCompleted'],
        'orderAmountReceived': json['orderAmountReceived'] === undefined ? undefined : json['orderAmountReceived'] === null ? null : json['orderAmountReceived'],
        'orderAmountCancelled': json['orderAmountCancelled'] === undefined ? undefined : json['orderAmountCancelled'] === null ? null : json['orderAmountCancelled'],
        'orderAmountNetGranular': json['orderAmountNetGranular'] == null ? undefined : json['orderAmountNetGranular'],
        'orderAmountGrossGranular': json['orderAmountGrossGranular'] == null ? undefined : json['orderAmountGrossGranular'],
        'orderAmountCompletedGranular': json['orderAmountCompletedGranular'] == null ? undefined : json['orderAmountCompletedGranular'],
        'orderAmountReceivedGranular': json['orderAmountReceivedGranular'] == null ? undefined : json['orderAmountReceivedGranular'],
        'orderAmountCancelledGranular': json['orderAmountCancelledGranular'] == null ? undefined : json['orderAmountCancelledGranular'],
    };
}

export function ShopPerformanceToJSON(json: any): ShopPerformance {
    return ShopPerformanceToJSONTyped(json, false);
}

export function ShopPerformanceToJSONTyped(value?: ShopPerformance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderAverageNet': NullableMoneyOutputToJSON(value['orderAverageNet']),
        'orderAverageNetGranular': value['orderAverageNetGranular'] == null ? undefined : (mapValues(value['orderAverageNetGranular'], NullableMoneyOutputToJSON)),
        'orderAverageGross': NullableMoneyOutputToJSON(value['orderAverageGross']),
        'orderAverageGrossGranular': value['orderAverageGrossGranular'] == null ? undefined : (mapValues(value['orderAverageGrossGranular'], NullableMoneyOutputToJSON)),
        'orderProfitNet': NullableMoneyOutputToJSON(value['orderProfitNet']),
        'orderProfitNetGranular': value['orderProfitNetGranular'] == null ? undefined : (mapValues(value['orderProfitNetGranular'], NullableMoneyOutputToJSON)),
        'orderProfitGross': NullableMoneyOutputToJSON(value['orderProfitGross']),
        'orderProfitGrossGranular': value['orderProfitGrossGranular'] == null ? undefined : (mapValues(value['orderProfitGrossGranular'], NullableMoneyOutputToJSON)),
        'purchaseCostCompleteNet': value['purchaseCostCompleteNet'],
        'purchaseCostCompleteGross': value['purchaseCostCompleteGross'],
        'currency': value['currency'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
        'mediaSourceQualityGranular': value['mediaSourceQualityGranular'] == null ? undefined : (mapValues(value['mediaSourceQualityGranular'], MediaSourceQualityToJSON)),
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'partialProfitabilityGranular': value['partialProfitabilityGranular'] == null ? undefined : (mapValues(value['partialProfitabilityGranular'], PartialProfitabilityDataToJSON)),
        'partialProfitabilityMarketing': PartialProfitabilityDataToJSON(value['partialProfitabilityMarketing']),
        'partialProfitabilityMarketingGranular': value['partialProfitabilityMarketingGranular'] == null ? undefined : (mapValues(value['partialProfitabilityMarketingGranular'], PartialProfitabilityDataToJSON)),
        'centreSpendAttribution': CentreSpendAttributionDataToJSON(value['centreSpendAttribution']),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
        'orderTurnoverNet': NullableMoneyOutputToJSON(value['orderTurnoverNet']),
        'orderTurnoverNetGranular': value['orderTurnoverNetGranular'] == null ? undefined : (mapValues(value['orderTurnoverNetGranular'], MoneyOutputToJSON)),
        'orderTurnoverGross': NullableMoneyOutputToJSON(value['orderTurnoverGross']),
        'orderTurnoverCancelled': NullableMoneyOutputToJSON(value['orderTurnoverCancelled']),
        'cancelledTurnoverUnavailableReason': value['cancelledTurnoverUnavailableReason'],
        'cancelledTurnoverUnavailableReasonsGranular': value['cancelledTurnoverUnavailableReasonsGranular'],
        'orderTurnoverGrossGranular': value['orderTurnoverGrossGranular'] == null ? undefined : (mapValues(value['orderTurnoverGrossGranular'], MoneyOutputToJSON)),
        'orderTurnoverCancelledGranular': value['orderTurnoverCancelledGranular'] == null ? undefined : (mapValues(value['orderTurnoverCancelledGranular'], NullableMoneyOutputToJSON)),
        'orderSpendGoodsNet': NullableMoneyOutputToJSON(value['orderSpendGoodsNet']),
        'orderSpendGoodsGross': NullableMoneyOutputToJSON(value['orderSpendGoodsGross']),
        'purchaseCostUnknownNet': value['purchaseCostUnknownNet'],
        'purchaseCostUnknownGross': value['purchaseCostUnknownGross'],
        'purchaseCostEstimatedNet': value['purchaseCostEstimatedNet'],
        'purchaseCostEstimatedGross': value['purchaseCostEstimatedGross'],
        'purchaseCostQualityAvailable': value['purchaseCostQualityAvailable'],
        'purchaseCostUnknownNetGranular': value['purchaseCostUnknownNetGranular'],
        'purchaseCostUnknownGrossGranular': value['purchaseCostUnknownGrossGranular'],
        'purchaseCostEstimatedNetGranular': value['purchaseCostEstimatedNetGranular'],
        'purchaseCostEstimatedGrossGranular': value['purchaseCostEstimatedGrossGranular'],
        'purchaseCostQualityAvailableGranular': value['purchaseCostQualityAvailableGranular'],
        'orderSpendGoodsNetGranular': value['orderSpendGoodsNetGranular'] == null ? undefined : (mapValues(value['orderSpendGoodsNetGranular'], MoneyOutputToJSON)),
        'orderSpendGoodsGrossGranular': value['orderSpendGoodsGrossGranular'] == null ? undefined : (mapValues(value['orderSpendGoodsGrossGranular'], MoneyOutputToJSON)),
        'orderSpendMarketing': NullableMoneyOutputToJSON(value['orderSpendMarketing']),
        'orderSpendMarketingGranular': value['orderSpendMarketingGranular'] == null ? undefined : (mapValues(value['orderSpendMarketingGranular'], MoneyOutputToJSON)),
        'orderAmountNet': value['orderAmountNet'],
        'orderAmountGross': value['orderAmountGross'],
        'orderAmountCompleted': value['orderAmountCompleted'],
        'orderAmountReceived': value['orderAmountReceived'],
        'orderAmountCancelled': value['orderAmountCancelled'],
        'orderAmountNetGranular': value['orderAmountNetGranular'],
        'orderAmountGrossGranular': value['orderAmountGrossGranular'],
        'orderAmountCompletedGranular': value['orderAmountCompletedGranular'],
        'orderAmountReceivedGranular': value['orderAmountReceivedGranular'],
        'orderAmountCancelledGranular': value['orderAmountCancelledGranular'],
    };
}

